module.exports = __webpack_public_path__ + "img/icon_input_vimeo.b50ec41.svg";